let convertPriceToSourceCurrencyValue = (isSourceCurrency, item, value) => {
  if (isSourceCurrency) {
    return item[value + "_src_cur"];
  }
  return item[value];
};

export default convertPriceToSourceCurrencyValue;
